import { Divider, Flex } from '@chakra-ui/react';
import { memo } from 'react';

import { EditBackgroundColor } from './EditBackgroundColor';
import { EditBackgroundPattern } from './EditBackgroundPattern';
import { EditPageSize } from './EditPageSize';
import { PageNumberMenu } from './PageNumberMenu';

export const PageMenu = memo(() => {
  return (
    <Flex data-testid='page-menu' gap={3}>
      <EditBackgroundColor />
      <EditBackgroundPattern />
      <Divider orientation='vertical' />
      <EditPageSize />
      <Divider orientation='vertical' />
      <PageNumberMenu />
    </Flex>
  );
});
PageMenu.displayName = 'PageMenu';
